import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CardPackage } from '@app/src/views/MyPackage/listMyPackage';
import { Container } from './styled';
import { Title } from '@app/src/common/Title';
import {
  TotalAvailable,
  ListPackage,
  Disclaimer,
  Item,
  ButtonBack,
  IconBack,
  DisclaimerWrapper
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { clearPackageConsumeData, fetchPackageConsume } from '@app/src/views/Package/listPackage';
import { isClientEnv } from '@app/src/utils/validations';
import { ListMyPackageShimmer } from './ListMyPackageShimmer';

const isClient = isClientEnv();

export const ListMyPackage: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { categoryId } = useParams();
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));

  const isLoading = useSelector(state => state.package.isFetchingConsume);
  const packageConsume = useSelector(state => state.package.dataConsume.packages);
  const totalAnnouncements = useSelector(state => state.package.dataConsume.totalAds);

  useEffect(() => {
    if (categoryId) {
      dispatch(fetchPackageConsume(userStorage && userStorage.data && userStorage.data.id, categoryId));
    } else {
      dispatch(fetchPackageConsume(userStorage && userStorage.data && userStorage.data.id));
    }
    return () => {
      dispatch(clearPackageConsumeData());
    }
  }, []);

  const handleGoBack = () => {
    history.push('/mi-cuenta');
  };

  return (
    <React.Fragment>
      <ButtonBack onClick={handleGoBack}>
        <IconBack>
          <Icon data-name="icon-back" fill="#00" height="16" width="16" />
        </IconBack>
      Regresar
    </ButtonBack>
      <Container>
        {
          isLoading ?
            <ListMyPackageShimmer />
            :
            <React.Fragment>
              {
                (totalAnnouncements) ?
                  <Title>Avisos Disponibles <TotalAvailable>{totalAnnouncements}</TotalAvailable></Title> : null
              }
              <ListPackage>
                {
                  packageConsume ? packageConsume.map((item, index) => (
                    <Item key={index}>
                      <CardPackage
                        packageName={item.name}
                        categoryName={item.categoryName}
                        newspaperDetail={item.ads}
                        extrachargeDetail={item.extracharges}
                        expirationDate={item.expirationDate}
                        urlPosting={item.urlPosting}
                      />
                    </Item>
                  ))
                    : <ListMyPackageShimmer />
                }
              </ListPackage>
              <DisclaimerWrapper>
                <Disclaimer>*Ten en cuenta que una vez consumidos todos los avisos de tu paquete, los extracargos no se podrán utilizar posteriormente</Disclaimer>
                <Disclaimer>
                  *Las fotoviñetas solo aplican para la edición de El Comercio (EC)
                </Disclaimer>
              </DisclaimerWrapper>
            </React.Fragment>
        }
      </Container>
    </React.Fragment>
  )
};